// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1msIi","title":"Header_title__RMvoX","left":"Header_left__3nsT6","clinicName":"Header_clinicName__3osIq"};